var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowlege(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D4E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4708 34H25.5296M29.059 21.9999C29.0607 20.7962 28.7546 19.6121 28.1698 18.5601C27.5849 17.5081 26.7408 16.6231 25.7176 15.9893C24.6944 15.3554 23.5261 14.9937 22.3237 14.9386C21.1213 14.8834 19.9248 15.1366 18.8479 15.6742C17.7709 16.2117 16.8493 17.0157 16.1706 18.0097C15.4919 19.0038 15.0787 20.1548 14.9702 21.3536C14.8616 22.5523 15.0615 23.7589 15.5506 24.8587C16.0398 25.9584 16.802 26.9148 17.7649 27.637V31.1763H26.2355V27.637C27.112 26.9816 27.8236 26.1308 28.3138 25.1523C28.8039 24.1737 29.0591 23.0943 29.059 21.9999Z",
    stroke: "#0257CA",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4688 12.8235V10H22.5276V12.8235H21.4688Z",
    fill: "#0257CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8235 21.1177H10V20.0588H12.8235V21.1177Z",
    fill: "#0257CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9993 21.1177H31.1758V20.0588H33.9993V21.1177Z",
    fill: "#0257CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6133 14.9304L29.6102 12.9335L30.3589 13.6822L28.362 15.6791L27.6133 14.9304Z",
    fill: "#0257CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4969 15.6791L13.5 13.6822L14.2487 12.9335L16.2456 14.9304L15.4969 15.6791Z",
    fill: "#0257CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowlege);
export default __webpack_public_path__ + "static/media/knowlege.5e80062bff3df4ceeff76675e804e93c.svg";
export { ForwardRef as ReactComponent };